import Image from "next/image";

import { AnimatedBgSvg } from "./animated-bg-svg";

interface BgPatternOverlayProps {
  /** Number of additional about-bg.svg tiles stacked under AnimatedBgSvg. */
  tileCount?: 1 | 2;
  /** Positioning + sizing classes for the absolute overlay. */
  className?: string;
}

const TILE_KEYS = ["a", "b"] as const;

/**
 * Decorative AnimatedBgSvg + about-bg.svg overlay used inside the rounded
 * blue cards on marketing pages. Caller is responsible for the absolute
 * positioning (so hero cards can extend the bounds beyond inset-0).
 */
export function BgPatternOverlay({
  tileCount = 1,
  className = "absolute inset-0 -z-10 overflow-hidden opacity-40",
}: BgPatternOverlayProps) {
  return (
    <div
      className={`pointer-events-none select-none ${className}`}
      aria-hidden="true"
    >
      <div className="flex min-h-full flex-col">
        <AnimatedBgSvg />
        {TILE_KEYS.slice(0, tileCount).map((key) => (
          <Image
            key={key}
            src="/marketing/backgrounds/about-bg.svg"
            alt=""
            width={1920}
            height={400}
            className="h-auto w-full shrink-0"
            draggable={false}
          />
        ))}
      </div>
    </div>
  );
}
